import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { applicationConstants } from '../../../../constants/applicationConstants';
import { applicationActions } from '../../../../actions/applicationActions';
import { roleConstants } from '../../../../constants/roleConstants';

class AgreementDeclineButton extends Component {
  render() {
    const { application, user, handleAgreementDecline, cls } = this.props;

    return (application.status === applicationConstants.STATUS_REVIEW ||
      application.status === applicationConstants.STATUS_REPEAT) &&
      user.role_id === roleConstants.ROLE_DEPARTMENT_AGENT ? (
      <Button className={cls} onClick={handleAgreementDecline(application.id, user.department_id)}>
        Отклонить согласование
      </Button>
    ) : (
      ''
    );
  }
}

const mapStateToProps = state => {
  const { adminApplications } = state;

  return {
    adminApplications
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const handleAgreementDecline = (application_id, department_id) => {
    return e =>
      dispatch(applicationActions.openAgreementDeclineModal(application_id, department_id));
  };
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,

    handleAgreementDecline
  };
};

const connectedAgreementDeclineButton = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AgreementDeclineButton);
export { connectedAgreementDeclineButton as AgreementDeclineButton };
